import React, { useState, useEffect } from 'react';
import classNames from 'classnames'
import { Button } from '../Buttons'

interface Props {
  children: any,
}


export const TextContainer:  React.FunctionComponent<Props> = ({
  children
}) => {

  const [readMore, setReadMore] = useState(false);
  const buttonTitle = !readMore ? 'Read more' : 'Show less';
  const textContainerClass = classNames('text-container--read-more', {
    ['text-container--read-more--active']: !readMore,
  });

  return (
    <>
      <div className={ textContainerClass }>
        { children }
      </div>
      <div className='m-t'>
        <Button
          title={ buttonTitle }
          filled='dark'
          onClick={ () => {
            setReadMore(!readMore)
          }}
        />
      </div>
    </>
  )
}